export const playlist = {
  queue: 14, // Current track in array index [], 0 indexed
  tracks: [
    {
      title: 'Sewerz',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/sewerz.jpg'),
      lyrics: "<p>(Verse 1)<br>Once in eternity<br>I was lasting for thousands of years<br>But never appeared on the</p><p>Face of the Earth<br>Where the sun was obscured by the clouds<br>And hidden away from the</p><p>Roots of the trees<br>Breathing waste over walls of disease<br>On the ghost of reality</p><p>Wishing to see<br>Beyond layers of sediment hardened<br>Imprisoning me</p><p>(Chorus)<br>So let me take you down<br>Inside it<br>And let us flow alone<br>Until you're on your own</p><p>And that's the price you pay<br>When you want it<br>Obtain it all and head on your journey back<br>On your journey back<br>On your journey back home</p><p>(Verse 2)<br>Inside the walls<br>The liquid flowing beside you stagnates<br>And deeper it falls</p><p>Into darkness awaits<br>At the bottom the pit is evolving<br>Into a new state</p><p>And is beckoning me<br>As the steam is arising inside<br>To a cryptic degree</p><p>Stepping at last<br>And the edge disappears from the sides<br>Eternally falling</p><p>(Chorus)</p><p>(Bridge) x 2<br>I feel it crushing me down<br>With its rotten fist<br>Is trickling<br>Flowing on circling</p><p>(Chorus)</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/sewerz.mp3'),
      loaded: false,
      length: 384, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.3525,
        0.4627,
        0.4753,
        0.8136,
        0.7256,
        0.6160,
        0.7405,
        0.7283,
        0.7882,
        0.8456,
        0.8415,
        0.7263,
        0.7239,
        0.7178,
        0.8705,
        0.8748,
        0.5467,
        0.8747,
        0.9061,
        0.9136,
        0.9021,
        0.9295,
        0.9470,
        0.9320,
        0.7757,
        0.6736,
        0.7346,
        0.8574,
        0.8647,
        0.6328,
        0.7986,
        0.8965,
        0.9011,
        0.8886,
        0.8918,
        0.7187,
        0.6295,
        0.6490,
        0.7134,
        0.7154,
        0.8802,
        0.9112,
        0.9308,
        0.9565,
        0.9576,
        0.9417,
        0.9440,
        0.9423,
        0.8827,
        0.9079,
        0.6898,
        0.8710,
        1.0000,
        0.0893
      ]
    },
    {
      title: 'The Craftenstock Corporation',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/the-craftenstock-corporation.jpg'),
      lyrics: "<p>(Verse 1)<br>Report to the facility<br>I've got my issued boots and a definite function<br>I'm stuck for an eternity<br>When will my luck rearrange and give me my life back?</p><p>Prepare for reality<br>You've got orders to push and data needs processing<br>Connect to the circuitry<br>Welcome home this is the final fallen nation</p><p>(Chorus)<br>You're on it<br>An endless win<br>Pummel down my sanity until it's razor thin<br>You're on it<br>A blameless sin<br>Once again we suffer on until the machine wins</p><p>(Verse 2)<br>Replace in the rotation<br>You work until you're scraped down and battered to end<br>Then comes the realization<br>Caught up in the sea and draining toward the factory</p><p>Dystopian outlook trapped<br>Within cogs of systems lubricate asphyxiation<br>Shift tones calls the pawns to snap<br>They're returning to task and resume their own depletion</p><p>(Chorus)</p><p>(Bridge) x 2<br>Always feeding, always beating, at the expense of me<br>Never ceasing, never breathing, all because of greed</p><p>(Chorus) x 2</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/the-craftenstock-corporation.mp3'),
      loaded: false,
      length: 257, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.5437,
        0.5842,
        0.5937,
        0.6675,
        0.8662,
        0.9337,
        0.8953,
        0.5748,
        0.7452,
        0.7166,
        0.7047,
        0.8781,
        0.8969,
        0.8949,
        0.9175,
        0.9181,
        0.9182,
        0.9359,
        0.7381,
        0.5089,
        0.5928,
        0.6332,
        0.7245,
        0.7783,
        0.7527,
        0.8953,
        0.8969,
        0.8962,
        0.9193,
        0.9287,
        0.9113,
        0.9496,
        0.8294,
        0.8720,
        0.8892,
        0.9404,
        0.9169,
        0.9519,
        0.9486,
        0.9804,
        0.9450,
        0.9950,
        1.0000,
        0.9653,
        0.8959,
        0.9290,
        0.9301,
        0.9391,
        0.9321,
        0.9368,
        0.9210,
        0.4006,
        0.2010,
        0.0022
      ]
    },
    {
      title: 'Snow Zone',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/snow-zone.jpg'),
      lyrics: "<p>(Verse 1)<br>You froze your thoughts inside your head<br>And shattered all your dreams instead</p><p>And picking up what's left to mend<br>A barren tundra is your end</p><p>With all this steel built around<br>And concrete growing from the ground</p><p>You're planted here to stay<br>And lost forever</p><p>No escape! x 3</p><p>(Verse 1)</p><p>(Chorus)<br>Welcome to the Snow Zone<br>Where time is froze beneath the heated ashes<br>Wilderness is all alone<br>And there's no escape from...</p><p>The Snow Zone</p><p>(Verse 2)<br>You've worked your fingers through the gloves<br>Gear and coat your only loves</p><p>Repetition eats away<br>You're lost forever</p><p>No escape</p><p>(Chorus)</p><p>(Verse 1)</p><p>No escape! x 8</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/snow-zone.mp3'),
      loaded: false,
      length: 344, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.0121,
        0.0379,
        0.1623,
        0.2191,
        0.4042,
        0.4407,
        0.5310,
        0.7609,
        0.7105,
        0.6598,
        0.8192,
        0.9212,
        0.9021,
        0.9026,
        0.9380,
        0.8890,
        0.8346,
        0.7231,
        0.4882,
        0.5420,
        0.5784,
        0.5623,
        0.6473,
        0.6830,
        0.7199,
        0.9735,
        0.9491,
        0.8209,
        0.8058,
        0.6148,
        0.6996,
        0.8559,
        1.0000,
        0.9099,
        0.8538,
        0.7910,
        0.7487,
        0.6419,
        0.7357,
        0.6893,
        0.7566,
        0.7772,
        0.8213,
        0.8321,
        0.8047,
        0.8120,
        0.7987,
        0.7869,
        0.6673,
        0.3328,
        0.1706,
        0.3272,
        0.0315,
        0.0016
      ]
    },
    {
      title: 'Mindshift',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/mindshift.jpg'),
      lyrics: "(Instrumental)",
      mp3src: require('../audio/full-length/nature-vs-humans/mindshift.mp3'),
      loaded: false,
      length: 299, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.5511,
        0.7484,
        0.8562,
        0.8977,
        0.8904,
        0.8637,
        0.7738,
        0.8144,
        0.8028,
        0.8193,
        0.8281,
        0.8010,
        0.8836,
        0.9142,
        0.9119,
        0.9074,
        0.9207,
        0.9336,
        0.9194,
        0.9691,
        0.9228,
        0.9334,
        0.8241,
        0.8411,
        0.8221,
        0.8831,
        0.8598,
        0.8465,
        0.8622,
        0.8857,
        0.8545,
        0.8856,
        1.0000,
        0.8852,
        0.8125,
        0.8685,
        0.8439,
        0.8625,
        0.7978,
        0.7978,
        0.7786,
        0.5923,
        0.6235,
        0.6924,
        0.8395,
        0.8468,
        0.8661,
        0.8389,
        0.8618,
        0.9095,
        0.7628,
        0.6956,
        0.6729,
        0.1253
      ]
    },
    {
      title: 'Hydrocompression',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/hydrocompression.jpg'),
      lyrics: "<p>(Verse 1)<br>As long as we declare the<br>Ancient truths of yester-year<br>Push beneath the crushing ocean<br>Of the heavy task your lung should</p><p>Exhale life throughout the air and<br>Claim the cache from which it paired<br>Processes of recollection<br>Drown into the dark reflection</p><p>(PreChorus)<br>Dive into the deep and<br>Burrow down into your sleep<br>Never awaken from your grave<br>Fall in rank below the waves</p><p>Dive into the deep and<br>Burrow down into your sleep<br>Never awaken from your grave<br>The sea will come to make you slave</p><p>(Chorus)<br>Hydrocompression<br>Overweight from dark regression<br>Hydrocompression<br>Crush down the deep oppression</p><p>(Verse 2)<br>Light and luminescent beings<br>Vanish into the ocean seams<br>Metal creaks and needles flare<br>Panic fills escaping air</p><p>Seal the door to save the rest<br>Conscious of their failed quest<br>Glass spider webs begin to weep<br>The dark condemns it's frigid sleep</p><p>(Prechorus)</p><p>(Chorus)</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/hydrocompression.mp3'),
      loaded: false,
      length: 380, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.5664,
        0.6840,
        0.7240,
        0.6860,
        0.8197,
        0.7945,
        0.8000,
        0.7633,
        0.7942,
        0.7429,
        0.7737,
        0.8054,
        0.7999,
        0.8050,
        0.8369,
        0.9487,
        0.9993,
        0.9826,
        0.9734,
        0.9179,
        0.7781,
        0.7149,
        0.7958,
        0.8167,
        0.8250,
        0.8041,
        0.9589,
        1.0000,
        0.9594,
        0.9911,
        0.9249,
        0.7485,
        0.6992,
        0.7105,
        0.7466,
        0.8239,
        0.7937,
        0.8697,
        0.9008,
        0.8922,
        0.8740,
        0.8685,
        0.8472,
        0.8356,
        0.8571,
        0.8602,
        0.8584,
        0.8725,
        0.8796,
        0.8044,
        0.6999,
        0.6394,
        0.6279,
        0.3913
      ]
    },
    {
      title: 'Evacuate',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/evacuate.jpg'),
      lyrics: "<p>(Verse 1)<br>Approach the end of thunder<br>Approach the end of rain<br>Discover corrosion remains</p><p>Attend a different function<br>Attend a distant place<br>It all will end up the same</p><p>(Chorus)<br>Coordinate<br>Plan it now; separate<br>Getaway<br>Shut down; evacuate</p><p>(Verse 2)<br>Believe in publication<br>Believe in diplomacy<br>Be fooled by their trickery</p><p>Commend the winning number<br>Commend your empty gain<br>Refuse to give up all the strain</p><p>(Chorus)</p><p>(Instrumental Break)</p><p>Evacuate! x 12</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/evacuate.mp3'),
      loaded: false,
      length: 276, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.1487,
        0.2244,
        0.4064,
        0.1854,
        0.2994,
        0.3265,
        0.1969,
        0.3888,
        0.6220,
        0.8322,
        0.8394,
        0.8369,
        0.8688,
        0.8503,
        0.8871,
        0.8505,
        0.6350,
        0.8292,
        0.8472,
        0.8416,
        0.8943,
        0.8621,
        0.7896,
        0.8721,
        0.8798,
        0.7210,
        0.6937,
        0.6941,
        0.8568,
        0.8467,
        0.8619,
        0.8728,
        0.8848,
        0.7672,
        0.8609,
        0.8832,
        0.9497,
        0.9631,
        0.9858,
        1.0000,
        0.9767,
        0.9853,
        0.9395,
        0.9637,
        0.9044,
        0.9707,
        0.9925,
        0.8014,
        0.3969,
        0.5698,
        0.5353,
        0.3282,
        0.4793,
        0.0529
      ]
    },
    {
      title: 'Arctic Assault',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/arctic-assault.jpg'),
      lyrics: "<p>(Verse 1)<br>Frozen winds obscure; Cold stone grey walls<br>Orders and honor; Celsius falls<br>Strategic outpost; Expendable<br>White clad minions run; Untraceable</p><p>(PreChorus)<br>Flashes interrupt; Thunderous rounds<br>Snow and ground erupts; Concussion sounds<br>Concrete shrapnel flies; Stops dead in flesh<br>Frozen crimson dries; And joins the rest</p><p>(Chorus)<br>Arctic assault, A polar tempest<br>Arctic assault, From man's iron fist<br>Arctic assault, For a military shell<br>Arctic assault, In a gray-scale hell</p><p>(Verse 2)<br>Black smoke billows forth; Bunker compound<br>Rebar and ribcage; The weakness found<br>Opposing forces; Invade inside<br>Close quarters combat; no time to hide</p><p>(PreChorus)</p><p>(Chorus)</p><p>(Bridge) x 2</p><p>Take the battlefield no matter what the cost</p><p>Whitewashed corpses join the permafrost</p><p>(Chorus)</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/arctic-assault.mp3'),
      loaded: false,
      length: 216, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.7443,
        0.8546,
        0.8402,
        0.8441,
        0.8818,
        0.8824,
        0.8996,
        0.9075,
        0.8628,
        0.8360,
        0.8303,
        0.8316,
        0.8542,
        0.9024,
        0.8965,
        0.9200,
        0.8562,
        0.9318,
        0.9576,
        0.9449,
        0.9539,
        0.8952,
        0.9287,
        0.9361,
        0.9492,
        0.8482,
        0.8446,
        0.8460,
        0.8574,
        0.8937,
        0.9140,
        0.9113,
        0.7151,
        0.4966,
        0.4940,
        0.4902,
        0.6818,
        0.9257,
        0.9394,
        0.9216,
        0.9398,
        0.9379,
        0.9282,
        1.0000,
        0.8360,
        0.9218,
        0.9421,
        0.9300,
        0.9575,
        0.7716,
        0.7417,
        0.7401,
        0.7419,
        0.1487
      ]
    },
    {
      title: 'Stasis',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/stasis.jpg'),
      lyrics: "(Instrumental)",
      mp3src: require('../audio/full-length/nature-vs-humans/stasis.mp3'),
      loaded: false,
      length: 230, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.2046,
        0.3251,
        0.3240,
        0.3462,
        0.3699,
        0.3827,
        0.6575,
        0.8294,
        0.5254,
        0.5152,
        0.5684,
        0.5520,
        0.5714,
        0.5841,
        0.7309,
        0.5507,
        0.6195,
        0.7793,
        0.8106,
        0.5877,
        0.4994,
        0.5430,
        0.7465,
        0.5786,
        1.0000,
        0.9409,
        0.6495,
        0.6278,
        0.8069,
        0.7640,
        0.7843,
        0.7390,
        0.7736,
        0.8782,
        0.8406,
        0.7954,
        0.6878,
        0.7371,
        0.6557,
        0.6936,
        0.6150,
        0.6395,
        0.6267,
        0.6447,
        0.4876,
        0.6179,
        0.7185,
        0.6518,
        0.6360,
        0.6109,
        0.3878,
        0.0737,
        0.0210,
        0.0029
      ]
    },
    {
      title: 'Nature Vs Humans',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/nature-vs-humans.jpg'),
      lyrics: "<p>(Verse 1)<br>Upon the lands<br>Upon the sands<br>Upon the shaking hands<br>Battles on the struggles for the foundation of every man</p><p>Think of hope<br>Think of dope<br>Think of all the ways we cope<br>Press on overhill to find ourselves upon a steeper slope</p><p>(Chorus)<br>We hope that nature makes it back to soothe the wound<br>That live or die in the end the earth is never ruined<br>And inevitable as it may be that man will never win<br>In the war of Nature Vs Humans</p><p>(Verse 2)<br>Haunt the trees<br>Haunt the leaves<br>Haunt the way that we perceive<br>We rely upon the earth that we cannot deceive</p><p>Let us breathe<br>Let us see<br>Let us all agree<br>To live together in our world and find our missing harmony</p><p>(Chorus)</p><p>Nature vs humans! x 20</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/nature-vs-humans.mp3'),
      loaded: false,
      length: 349, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.2782,
        0.3506,
        0.3595,
        0.4180,
        0.4738,
        0.5197,
        0.5156,
        0.5503,
        0.6320,
        0.6102,
        0.7857,
        0.7626,
        0.7809,
        0.6897,
        0.8209,
        0.8345,
        0.8591,
        0.9871,
        1.0000,
        0.9711,
        0.6886,
        0.5915,
        0.5376,
        0.6400,
        0.8628,
        0.8708,
        0.8947,
        0.9457,
        0.9704,
        0.9658,
        0.7406,
        0.7305,
        0.8412,
        0.9401,
        0.9490,
        0.9713,
        0.8961,
        0.6300,
        0.7855,
        0.8559,
        0.7997,
        0.7790,
        0.7449,
        0.9229,
        0.9775,
        0.9598,
        0.8372,
        0.4837,
        0.4661,
        0.4598,
        0.3454,
        0.3093,
        0.3576,
        0.1255
      ]
    },
    {
      title: 'Extraction Contingency Plan',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/extraction-contingency-plan.jpg'),
      lyrics: "<p>(Verse 1)<br>Whenever we get through<br>The unmistakable<br>I will make a home<br>That's interchangeable</p><p>Look at your future<br>Is it it plausible?<br>When the tie gets tough<br>Is it passable?</p><p>(PreChorus)<br>Forever in it's clutch<br>I can't move around<br>Squirming in it's grip<br>Pressure keeps me bound</p><p>Squeeze out all my life<br>Leaves me with a shell<br>I can see it now<br>Time can never re-tell</p><p>(Chorus)<br>God!<br>He made us live our lives<br>No turning back when we live to survive<br>God! He made us live our lives<br>No turning back when we live to survive</p><p>(Verse 2)<br>Approaching atmosphere<br>I find my vision clear<br>I often wonder why<br>We sit and stand in fear</p><p>We wake and push our lives<br>I plan and live it clear<br>With what I've given back<br>No shame to live in fear</p><p>Fear! x 3</p><p>(Instrumental Break)</p><p>(Chorus)</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/extraction-contingency-plan.mp3'),
      loaded: false,
      length: 192, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.8372,
        0.9495,
        0.9519,
        0.8713,
        0.8029,
        0.8264,
        0.8388,
        0.8104,
        0.8530,
        0.8867,
        0.8900,
        0.8149,
        0.7921,
        0.7745,
        0.8251,
        0.8793,
        0.8393,
        0.8744,
        0.8658,
        0.9780,
        0.8848,
        0.9181,
        0.9138,
        0.9422,
        0.9217,
        0.8473,
        0.8706,
        0.8790,
        0.8756,
        0.8988,
        0.8200,
        0.8007,
        0.8274,
        0.8501,
        0.7742,
        0.8096,
        0.8133,
        0.8181,
        0.8902,
        0.9458,
        0.8625,
        0.8009,
        0.8019,
        0.8291,
        0.8409,
        0.8478,
        0.8500,
        0.8618,
        0.9206,
        0.9329,
        1.0000,
        0.9753,
        0.3474,
        0.0015
      ]
    },
    {
      title: 'Perpetual Depths',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/perpetual-depths.jpg'),
      lyrics: "(Instrumental)",
      mp3src: require('../audio/full-length/nature-vs-humans/perpetual-depths.mp3'),
      loaded: false,
      length: 234, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.2468,
        0.3546,
        0.4888,
        0.5126,
        0.6003,
        0.6991,
        0.6890,
        0.7656,
        0.7880,
        0.7427,
        0.7666,
        0.8710,
        0.8169,
        0.8351,
        0.7882,
        0.8750,
        0.8247,
        0.8485,
        0.8014,
        0.8315,
        0.9849,
        0.9662,
        0.8416,
        0.8966,
        1.0000,
        0.9855,
        0.9567,
        0.8059,
        0.9354,
        0.5540,
        0.6189,
        0.5536,
        0.5817,
        0.7606,
        0.7955,
        0.8554,
        0.8359,
        0.8512,
        0.8192,
        0.8559,
        0.8451,
        0.8577,
        0.8406,
        0.8787,
        0.8620,
        0.8468,
        0.6854,
        0.4278,
        0.3292,
        0.2304,
        0.2738,
        0.1851,
        0.0322,
        0.0015
      ]
    },
    {
      title: 'Cold Ammonia Machine',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/cold-ammonia-machine.jpg'),
      lyrics: "<p>(Verse 1)<br>Venture into an outward time<br>Where space is in motion, and planets align<br>Changing the past for a future untold<br>Testing the liquids of mind that unfold</p><p>Fed through the pipes of frozen arrays<br>Pumping with fluids; it bows and it sways<br>Twisting and turning my thoughts are inept<br>Into the machinery my memory is swept</p><p>(Chorus)<br>Cold Ammonia Machine<br>It brings me back<br>It brings me into the belief that I<br>Cold Ammonia Machine<br>It brings me home<br>It brings me home...</p><p>(Verse 2)<br>Light years behind, and more within sight<br>Powered by humans; frozen in flight<br>Solar winds sail, the last ship has passed<br>Engines will churn as their own time stands fast</p><p>Robbing the minds of their time on the Earth<br>Squeezing them out to establish their worth<br>Breathing is all that they feel in their dreams<br>In the throes of the Cold Ammonia Machine</p><p>(Chorus) x 2</p><p>(Instrumental Bridge)</p><p>(Chorus)</p>",
      mp3src: require('../audio/full-length/nature-vs-humans/cold-ammonia-machine.mp3'),
      loaded: false,
      length: 320, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.3334,
        0.6132,
        0.9555,
        0.9921,
        0.8959,
        0.7456,
        0.8661,
        0.9558,
        0.8818,
        0.8778,
        0.9371,
        0.9011,
        1.0000,
        0.9799,
        0.9957,
        0.8400,
        0.8682,
        0.7821,
        0.7686,
        0.8992,
        0.9109,
        0.8446,
        0.8556,
        0.9183,
        0.9852,
        0.8730,
        0.8733,
        0.9768,
        0.9693,
        0.9634,
        0.9598,
        0.9475,
        0.9581,
        0.9500,
        0.7780,
        0.8393,
        0.7454,
        0.7153,
        0.6899,
        0.7036,
        0.7646,
        0.7547,
        0.7465,
        0.7653,
        0.7816,
        0.7292,
        0.9165,
        0.9656,
        0.9653,
        0.6061,
        0.4649,
        0.3115,
        0.4361,
        0.0608
      ]
    },
    {
      title: 'FGS 037-148',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/fgs-037-148.jpg'),
      lyrics: "(Instrumental)",
      mp3src: require('../audio/full-length/nature-vs-humans/fgs-037-148.mp3'),
      loaded: false,
      length: 192, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.2149,
        0.5736,
        0.5751,
        0.3300,
        0.3661,
        0.2862,
        0.3801,
        0.3199,
        0.3952,
        0.3885,
        0.3867,
        0.6470,
        0.6274,
        0.5575,
        0.5485,
        0.5835,
        0.5507,
        0.6395,
        0.5536,
        0.8699,
        0.8980,
        0.8802,
        0.8721,
        0.9320,
        0.9504,
        0.8884,
        0.9182,
        0.9349,
        0.8973,
        0.9189,
        0.9037,
        0.9543,
        0.9516,
        0.7991,
        0.8817,
        0.8409,
        0.8757,
        0.9145,
        0.9293,
        0.8400,
        0.9132,
        0.9130,
        0.8673,
        0.9088,
        1.0000,
        0.9125,
        0.9215,
        0.9857,
        0.9974,
        0.8032,
        0.7054,
        0.7186,
        0.4899,
        0.0016
      ]
    },
    {
      title: 'Distress Signal',
      album: 'Nature Vs Humans',
      albumartwork: require('../audio/artwork/nature-vs-humans-album.jpg'),
      songartwork: require('../audio/artwork/distress-signal.jpg'),
      lyrics: "(Instrumental)",
      mp3src: require('../audio/full-length/nature-vs-humans/distress-signal.mp3'),
      loaded: false,
      length: 277, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.2684,
        0.5270,
        0.4706,
        0.6485,
        0.6137,
        0.6447,
        0.5423,
        0.5560,
        0.6245,
        0.7205,
        0.7886,
        0.7702,
        0.8401,
        0.7382,
        0.7732,
        0.6978,
        0.7486,
        0.9271,
        1.0000,
        0.8146,
        0.7266,
        0.6653,
        0.6011,
        0.7210,
        0.6466,
        0.5692,
        0.4553,
        0.4811,
        0.4574,
        0.2392,
        0.1325,
        0.1405,
        0.3738,
        0.4261,
        0.3870,
        0.4568,
        0.3738,
        0.3734,
        0.3994,
        0.3761,
        0.4560,
        0.3823,
        0.4126,
        0.3602,
        0.3778,
        0.4216,
        0.3995,
        0.4444,
        0.3737,
        0.3645,
        0.4121,
        0.3773,
        0.2522,
        0.0035
      ]
    },
    {
      title: 'Belt Driven Tragedy',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/belt-driven-tragedy.jpg'),
      lyrics: "<p>(Intro)<br>Why?<br>Why?</p><p>Yaahh!</p><p>(Verse 1)<br>Another reason to look past the sullen eyes<br>Heading into a battered work zone dehumanized<br>They risk their lives troubled off by complacency<br>An effort works, harrowed on by</p><p>Reality!</p><p>(Chorus 1)<br>Belt driven tragedy<br>A company ordered catastrophe<br>Guise<br>A hidden corporate loss<br>Cook all the numbers, kick up to the boss</p><p>(Verse 2)<br>I found escape is a definite function<br>Another way to release from assumption<br>It all depends on the world that is real<br>But freedom escapes, so</p><p>Set me free!</p><p>(Chorus 2)</p><p>Kick up to the boss!<br>Kick up to the boss!</p><p>(Instrumental Break)</p><p>Why? x 4</p><p>(Chorus)</p><p>(Bridge) x 2<br>You don't believe me<br>I started heaving<br>Let me restate<br>That the worker's not breathing</p><p>Why?</p><p>(Chorus)</p><p>I am lost!<br>Kick up to the boss!<br>I am lost!</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/belt-driven-tragedy.mp3'),
      loaded: false,
      length: 261, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.7160,
        0.7620,
        0.8055,
        0.8063,
        0.7958,
        0.7659,
        0.7786,
        0.7449,
        0.8583,
        0.8815,
        0.9411,
        1.0000,
        0.9489,
        0.9732,
        0.9511,
        0.6841,
        0.6040,
        0.6761,
        0.5931,
        0.8819,
        0.8730,
        0.9238,
        0.9712,
        0.9567,
        0.9545,
        0.9540,
        0.8131,
        0.6750,
        0.6588,
        0.7107,
        0.7436,
        0.7059,
        0.8920,
        0.7938,
        0.7973,
        0.7880,
        0.7348,
        0.8512,
        0.9388,
        0.9170,
        0.9175,
        0.8625,
        0.7180,
        0.9107,
        0.8970,
        0.9261,
        0.9111,
        0.9204,
        0.9151,
        0.5107,
        0.4067,
        0.4071,
        0.3242,
        0.0207
      ]
    },
    {
      title: 'Underling',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/underling.jpg'),
      lyrics: "<p>(Verse 1)<br>He sits for light years drinking his potion<br>Swallow it down, he suppresses emotion<br>I see it now he's another devotion<br>To the Craftenstock essential promotion</p><p>(PreChorus)<br>He's feeling out of form<br>Fulfilling the orders is always the norm<br>Worn out and broken gears<br>Forever assembling tears</p><p>(Chorus)<br>The Underling has reached his end<br>By-product company spend<br>Recreate the factory pool<br>Another disposable tool</p><p>(Verse 2)<br>He is a nightmare, feeling corrosion<br>Break down his gears, speeding erosion<br>Man or machine, I welcome the change<br>To the rusted-out, broken-down labor we face</p><p>(PreChorus)</p><p>(Instrumental Bridge)</p><p>Arrgghh!</p><p>(Chorus) x 2</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/underling.mp3'),
      loaded: false,
      length: 219, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.1515,
        0.1662,
        0.2261,
        0.3615,
        0.7431,
        0.7850,
        0.7236,
        0.7816,
        0.7703,
        0.7885,
        0.7736,
        0.8234,
        0.7423,
        0.8803,
        0.8908,
        0.9444,
        0.9476,
        0.9001,
        0.8716,
        0.8933,
        0.9151,
        0.9058,
        0.9070,
        0.8880,
        0.9477,
        0.9402,
        1.0000,
        0.9747,
        0.9080,
        0.8689,
        0.8994,
        0.7926,
        0.6541,
        0.6412,
        0.6635,
        0.7355,
        0.7329,
        0.6853,
        0.8058,
        0.6983,
        0.8197,
        0.7002,
        0.7483,
        0.5349,
        0.8733,
        0.8915,
        0.9226,
        0.8820,
        0.9024,
        0.9111,
        0.9214,
        0.8460,
        0.4953,
        0.2141
      ]
    },
    {
      title: 'The Factory Bloc',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/the-factory-bloc.jpg'),
      lyrics: "<p>(Intro)<br>The Factory Bloc!<br>The Factory Bloc!</p><p>(Verse 1)<br>Blowing smoke billows out thick to smother<br>Rising heat from the ground burns another</p><p>(PreChorus)<br>These draining pipes<br>They cause disease<br>Trickle down complacency</p><p>(Chorus)<br>The Factory Bloc is on the rise<br>Spread through the land and sterilize<br>No looking back from the changes we make<br>Shadows of progress fade<br>Our futures we take</p><p>(PostChorus)<br>Industry breathes through the fields<br>Intoxicate<br>We'll never be looking back<br>It's taken me</p><p>(Verse 2)<br>Glowing hope pillows out on the workplace<br>Quickly smothers the burden of our fate</p><p>(PreChorus)</p><p>(Chorus)</p><p>(Instrumental Break)</p><p>(Chorus)</p><p>(Outro) x 2<br>Get me out of the Bloc<br>Take me away from the pacing faces<br>Get me out of the Bloc<br>I'd rather flee than be in stasis</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/the-factory-bloc.mp3'),
      loaded: false,
      length: 253, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.7348,
        0.8476,
        0.9498,
        0.9550,
        0.9580,
        0.9480,
        0.8054,
        0.8186,
        0.8301,
        0.9210,
        0.9314,
        0.9645,
        1.0000,
        0.8499,
        0.9009,
        0.8968,
        0.8961,
        0.9509,
        0.9764,
        0.9798,
        0.9402,
        0.8290,
        0.8173,
        0.8678,
        0.9039,
        0.9717,
        0.9570,
        0.9879,
        0.6613,
        0.6565,
        0.5999,
        0.6901,
        0.8240,
        0.7913,
        0.7958,
        0.8469,
        0.9179,
        0.9642,
        0.9659,
        0.5849,
        0.4452,
        0.4487,
        0.4947,
        0.8735,
        0.8794,
        0.9097,
        0.8891,
        0.8654,
        0.9005,
        0.8708,
        0.4684,
        0.1588,
        0.1326,
        0.0538
      ]
    },
    {
      title: 'Polar Vortex',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/polar-vortex.jpg'),
      lyrics: "<p>(Verse 1)<br>Peering through covered eyes<br>Continuing to paralyze<br>Snow an ocean white<br>Piling on without emotion</p><p>Trudging up to my knees<br>Frigid air falling degrees<br>Grind-halt efficiency<br>Constricting locomotion</p><p>(PreChorus)<br>And I am freezing down<br>Polar crest<br>Collapse to the ground<br>The air burns in my chest</p><p>I'm freezing down<br>Polar crest<br>My final mistake is<br>I froze with the rest</p><p>(Chorus) x 2<br>Shivering limbs<br>Cover my face<br>Swallowed by the<br>Polar vortex</p><p>(Verse 2)<br>Wading up to my thighs<br>Howling wind drowns out my cries<br>Moving gets hard to try<br>Breaking through the icy shell</p><p>Enveloped in a pale cast<br>Temperature dropping so fast<br>These steps could be my last<br>Could not get up once I fell</p><p>(Instrumental Break)</p><p>(Chorus) x 2</p><p>(Instrumental Break)</p><p>(Chorus) x 2</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/polar-vortex.mp3'),
      loaded: false,
      length: 273, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.7634,
        0.7003,
        0.7032,
        0.7399,
        0.7828,
        0.7209,
        0.7039,
        0.8122,
        0.8189,
        0.8155,
        0.8414,
        0.8617,
        0.8468,
        0.8362,
        0.8891,
        0.9651,
        1.0000,
        0.9851,
        0.9811,
        0.7534,
        0.7678,
        0.7632,
        0.8031,
        0.8230,
        0.8374,
        0.8299,
        0.6878,
        0.6920,
        0.6476,
        0.6130,
        0.6343,
        0.7169,
        0.7970,
        0.7823,
        0.7909,
        0.9640,
        0.9830,
        0.9660,
        0.9589,
        0.5933,
        0.6142,
        0.6872,
        0.7460,
        0.8013,
        0.8169,
        0.8153,
        0.8164,
        0.8273,
        0.9815,
        0.9946,
        0.9758,
        0.8845,
        0.5529,
        0.3843
      ]
    },
    {
      title: 'Empty',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/empty.jpg'),
      lyrics: "<p>(Verse 1)<br>I've worked for a hundred days<br>My time off is a life away<br>And I waste my time to stay<br>At another forgettable crumbling place</p><p>So let's talk the conditions here<br>The sun above won't interfere<br>The air I choke is never clear<br>And the chemicals burn my eyes</p><p>(PreChorus)<br>I look upon all of their faces<br>They look alone<br>They must be generated</p><p>(Chorus) x 2<br>Into the outside<br>I'm empty<br>Burning on the inside<br>Frozen on the out<br>I'm ending</p><p>(Instrumental Post-Chorus)</p><p>(Instrumental Chorus)</p><p>(Verse 2)<br>Around here the sky it bleeds<br>It cries hard from the fumes it breaths<br>And coughs out all the acid steam<br>At another forgettable factory</p><p>So I fought with the engineers<br>They labeled me a mutineer<br>And sent me off without a tear<br>Into the cold and wet goodbye</p><p>(PreChorus)</p><p>(Chorus) x 2</p><p>(Instrumental Post-Chorus)</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/empty.mp3'),
      loaded: false,
      length: 252, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.1323,
        0.4546,
        0.5484,
        0.9364,
        0.8896,
        0.9023,
        0.9080,
        0.8959,
        0.8822,
        0.8184,
        0.8226,
        0.8358,
        0.8222,
        0.8109,
        0.7933,
        0.8380,
        0.8265,
        0.8548,
        0.8627,
        0.8584,
        0.9441,
        0.8904,
        1.0000,
        0.9290,
        0.9188,
        0.9437,
        0.9028,
        0.9467,
        0.9681,
        0.9260,
        0.9846,
        0.7944,
        0.8907,
        0.8414,
        0.8610,
        0.8623,
        0.8024,
        0.8560,
        0.8153,
        0.8467,
        0.8740,
        0.8403,
        0.9484,
        0.9266,
        0.9762,
        0.9889,
        0.8918,
        0.9322,
        0.9405,
        0.9140,
        0.9085,
        0.9761,
        0.9167,
        0.7720
      ]
    },
    {
      title: 'Tentacle',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/tentacle.jpg'),
      lyrics: "<p>(Verse 1)<br>It all starts on a hazy night<br>It all breaks when you're losing traction<br>It all ends when you realize<br>You're wrapped up and you're paralyzed</p><p>It all quakes when you've been deceived<br>It all makes a deceptive notion<br>It's all fake when you analyze<br>You're mind's bombed and you're sterilized</p><p>(Chorus) x 2<br>Abandoned<br>And stranded<br>These tentacles are dragging my hands in<br>There's no hope<br>All alone<br>This stranglehold is the end of my rope</p><p>(Break)<br>I'm fading in the light<br>I see the darkness drain to oceans<br>My brain is hypnotized<br>I'll fall asleep and feel the potion</p><p>(Chorus)</p><p>(Instrumental Break)</p><p>(Bridge) x 2<br>I'm fading in the light<br>I see the darkness drain to oceans<br>My brain is hypnotized<br>I'll fall asleep and feel the potion</p><p>(Verse 2)<br>It all starts when you make the senses<br>I smell the oily tentacle stenches<br>Growing out of sea and harbor<br>Moving closer and creeping harder</p><p>Grabbing on I savor my breath<br>Dragging me into the last depth<br>This trapping feel has got to go<br>But that's a feeling I'll never know</p><p>(Chorus) x 2</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/tentacle.mp3'),
      loaded: false,
      length: 243, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.5270,
        0.7376,
        0.5994,
        0.7228,
        0.8494,
        0.7456,
        0.7268,
        0.8188,
        0.7524,
        0.7142,
        0.8381,
        0.8606,
        0.7812,
        0.8643,
        0.8847,
        0.7965,
        0.8904,
        1.0000,
        0.7911,
        0.8703,
        0.9340,
        0.8406,
        0.9051,
        0.9307,
        0.7293,
        0.8417,
        0.8858,
        0.8030,
        0.9227,
        0.8434,
        0.5410,
        0.6392,
        0.7190,
        0.7336,
        0.7364,
        0.8506,
        0.9384,
        0.9035,
        0.9226,
        0.9342,
        0.9174,
        0.9255,
        0.8161,
        0.8606,
        0.9172,
        0.8528,
        0.8753,
        0.9435,
        0.8475,
        0.9124,
        0.8984,
        0.9093,
        0.9263,
        0.3578
      ]
    },
    {
      title: 'Sentient',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/sentient.jpg'),
      lyrics: "<p>(Verse 1)<br>A stoic mind<br>Grown out of place<br>Sentiment is so far gone<br>From human interface</p><p>Afraid of truth<br>Scared of light<br>Another reason why<br>The brain is fully terrified</p><p>(PreChorus)<br>I know it's living and breathing<br>But is it really feeling?<br>I can't control the being inside<br>When I look into it's eyes</p><p>(Chorus) x 2<br>Your mind is fully sentient<br>Continue to rule, are we arrogant?<br>Nobody places their life on the Earth<br>With visions of healing worlds</p><p>(Verse 2)<br>I clone my mind<br>My body moves<br>Can it be I've found<br>The way to seeking inner truth?</p><p>Depraved of might<br>Lost of sooth<br>Getting weaker by the hour<br>Stuck in this cocoon</p><p>(PreChorus)</p><p>(Bridge)<br>Sentient! x 4</p><p>It's the end!</p><p>(Verse 1)</p><p>(Chorus) x 2</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/sentient.mp3'),
      loaded: false,
      length: 248, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.4686,
        0.6560,
        0.8481,
        0.8623,
        0.8275,
        0.7702,
        0.7992,
        0.8435,
        0.8271,
        0.8489,
        0.8216,
        0.8155,
        0.9015,
        0.7383,
        0.7772,
        0.7590,
        0.7928,
        0.8311,
        0.8612,
        0.9147,
        0.8862,
        0.8843,
        0.8663,
        0.8650,
        0.8729,
        0.8884,
        0.8564,
        0.7938,
        0.7561,
        0.7792,
        0.8113,
        0.8216,
        0.8463,
        0.8746,
        0.9647,
        0.9521,
        0.9775,
        0.9505,
        0.9876,
        1.0000,
        0.9684,
        0.9775,
        0.7907,
        0.7809,
        0.7990,
        0.9395,
        0.8649,
        0.8901,
        0.8682,
        0.8993,
        0.8733,
        0.8561,
        0.8166,
        0.0593
      ]
    },
    {
      title: 'Anesthesiac',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/anesthesiac.jpg'),
      lyrics: "<p>(Verse 1)<br>You've never seen a fiend like him<br>Self-inflicted, a victim<br>Never happy with his state of never wanting life again</p><p>Inebriated costs<br>Mind wandering and lost<br>Just crawling for an episode of temporary pause</p><p>(PreChorus)<br>Emaciated face<br>An empty husk in the void</p><p>His extinguishing pace</p><p>(Chorus) x 2<br>Anesthesiac<br>What kind of life-form?<br>Storming throughout his brain<br>Addicted to reality torn</p><p>(Instrumental Break)</p><p>(Verse 2)<br>You'll never trust a man like him<br>Exposing in his whim<br>Wanting only certain drugs that let him drown instead of swim</p><p>While sinking down below<br>Hiding so no one knows<br>Trading fading peace forgets the growing stranglehold</p><p>(PreChorus)</p><p>(Chorus) x 4</p><p>(Bridge A) x 2<br>He's hiding deeper<br>Become a creeper<br>Riding high while<br>He faces the Reaper</p><p>(Bridge B) x 2<br>He's hiding deeper<br>Become a sleeper<br>Riding high while<br>He faces the Reaper</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/anesthesiac.mp3'),
      loaded: false,
      length: 232, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.3300,
        0.3737,
        0.8201,
        0.8786,
        0.9063,
        0.9082,
        0.8728,
        0.8537,
        0.8530,
        0.8447,
        0.8973,
        0.9641,
        0.9533,
        0.9851,
        0.9806,
        0.9726,
        0.9657,
        0.9634,
        1.0000,
        0.9259,
        0.8741,
        0.9031,
        0.8905,
        0.9431,
        0.9579,
        0.9571,
        0.9563,
        0.9818,
        0.9578,
        0.9631,
        0.9804,
        0.9399,
        0.9787,
        0.9529,
        0.9763,
        0.8366,
        0.7560,
        0.7299,
        0.7632,
        0.9133,
        0.9284,
        0.8779,
        0.9467,
        0.9111,
        0.8448,
        0.8430,
        0.8601,
        0.9016,
        0.9390,
        0.9627,
        0.9815,
        0.9446,
        0.4085,
        0.2753
      ]
    },
    {
      title: 'Thief in the Night',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/thief-in-the-night.jpg'),
      lyrics: "<p>(Verse 1)<br>You dream of money and prize<br>I see through your disguise<br>I see the way you snake around and bite</p><p>You’re a knife that stabs in the back<br>You’ve taken all of my check<br>And turned it to the source of all of your might</p><p>(Pre-Chorus 1)<br>The source of all of your might!<br>The source of all of your might!</p><p>(Chorus)<br>You had me taken away like a thief in the night<br>You stole all my riches and left me to fight<br>I’ll say goodbye now cause you sent me to fry<br>You’re a thief in the night</p><p>(Verse 2)<br>You scheme for your every need<br>I’ll catch you up to speed<br>I’m growing wiser to your endless greed</p><p>You ride on your victim’s backs<br>You grind ‘em down to the tracks<br>And issue punishment when anyone reacts</p><p>(Pre-Chorus 2)<br>Punishment when anyone reacts!<br>Punishment when anyone reacts!</p><p>(Chorus)</p><p>(Instrumental Break)</p><p>(Bridge) x 4<br>You’re a thief in the night!</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/thief-in-the-night.mp3'),
      loaded: false,
      length: 238, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.3487,
        0.5784,
        0.8562,
        0.8286,
        0.8364,
        0.8452,
        0.8432,
        0.8767,
        0.8516,
        0.9210,
        0.7917,
        0.9247,
        0.8187,
        0.9512,
        0.9169,
        0.9252,
        0.9250,
        0.9294,
        0.8514,
        0.9081,
        0.8474,
        0.9314,
        0.8382,
        0.9449,
        0.8444,
        0.9913,
        0.9171,
        0.9194,
        0.9632,
        0.8419,
        0.8322,
        0.7497,
        0.7721,
        0.8611,
        0.8222,
        0.8277,
        0.8328,
        0.9524,
        0.8878,
        0.8868,
        0.8665,
        0.8910,
        0.8653,
        0.8850,
        0.8437,
        0.9550,
        0.9432,
        0.9784,
        0.9429,
        0.9879,
        0.9542,
        0.9784,
        1.0000,
        0.2143
      ]
    },
    {
      title: 'Cryoscorch',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/cryoscorch.jpg'),
      lyrics: "<p>(Chorus)<br>Refrozen in the burning Cryoscorch<br>Cryoscorch!<br>An icy blast of wind that's a blowing torch<br>Cryoscorch!</p><p>(Verse 1)<br>I see the frozen air as it pushes down<br>Cold triggers snaps it's eternal crown<br>Fall breaks the leaves and marries the scent<br>Of the coming ice and the burning breath</p><p>(Chorus)</p><p>(Verse 2)<br>My hands are burning hard from cold cement<br>Icy blades of steel protrude from the vents<br>I'm moving through the wind trying to re-obtain<br>My lost sight to ever be whole again</p><p>To be whole again!<br>To be whole again!</p><p>(Chorus) x 2</p><p>(Instrumental Break)</p><p>(Chorus)</p><p>(Outro) x 4<br>Now I’m waking up<br>I’ll self destruct<br>The burning frostbite<br>Will eat me up</p>",
      mp3src: require('../audio/full-length/the-factory-bloc/cryoscorch.mp3'),
      loaded: false,
      length: 201, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.8596,
        0.9215,
        0.9542,
        0.9228,
        0.9214,
        0.8486,
        0.8785,
        0.8794,
        0.9101,
        0.9240,
        0.9460,
        0.9268,
        0.9052,
        0.8514,
        0.8641,
        0.8845,
        0.8870,
        0.9050,
        0.9055,
        0.9055,
        0.9293,
        0.9224,
        0.9547,
        0.9145,
        0.9528,
        0.9064,
        0.9667,
        0.9103,
        1.0000,
        0.8599,
        0.9133,
        0.9289,
        0.8880,
        0.8832,
        0.8865,
        0.8671,
        0.8708,
        0.8395,
        0.9786,
        0.9011,
        0.9512,
        0.7972,
        0.7458,
        0.8125,
        0.7562,
        0.8833,
        0.8623,
        0.8933,
        0.8839,
        0.9047,
        0.8971,
        0.8851,
        0.9045,
        0.1528
      ]
    },
    {
      title: 'Earth Takes Over',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/earth-takes-over.jpg'),
      lyrics: "(Instrumental)",
      mp3src: require('../audio/full-length/the-factory-bloc/earth-takes-over.mp3'),
      loaded: false,
      length: 116, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.3834,
        0.7738,
        0.7094,
        0.7129,
        0.8833,
        0.9150,
        0.8910,
        0.8876,
        0.9594,
        0.8317,
        0.8737,
        0.7870,
        0.8566,
        0.9730,
        0.8335,
        0.9037,
        0.9819,
        0.9213,
        0.9494,
        0.9683,
        0.9187,
        0.9638,
        0.9401,
        0.9838,
        0.8560,
        0.9024,
        0.9085,
        0.9521,
        0.9137,
        0.8818,
        0.9978,
        1.0000,
        0.9289,
        0.9832,
        0.9020,
        0.9848,
        0.9732,
        0.9262,
        0.9858,
        0.9488,
        0.9907,
        0.9322,
        0.9599,
        0.9515,
        0.8753,
        0.9475,
        0.8291,
        0.7415,
        0.8084,
        0.8672,
        0.7632,
        0.2077,
        0.0461,
        0.0023
      ]
    },
    {
      title: 'Abandon Launch',
      album: 'The Factory Bloc',
      albumartwork: require('../audio/artwork/the-factory-bloc-album.jpg'),
      songartwork: require('../audio/artwork/abandon-launch.jpg'),
      lyrics: "<p>(Intro)<br>Abandon launch!<br>Abandon launch!</p><p>(Verse 1)<br>I'm strapped down<br>A hundred meters from the ground<br>There's a rumbling outside<br>It's a terrifying sound</p><p>I feel the engines down below<br>Final seconds left to go<br>Procedure feeds your mind<br>But reality is slow</p><p>(Chorus)<br>I think I'm facing my final night<br>I've given years up to test this flight<br>I'm only racing to analyze<br>The night sky design</p><p>Abandon launch!<br>Abandon launch!<br>I'll never land the machine we wrought so<br>Abandon launch!</p><p>(Verse 2)<br>I'm still alive<br>A hundred tons are mechanized<br>Burning holes into the ground<br>Spraying liquid in my eyes</p><p>Meter reading is untold<br>Lights are flashing uncontrolled<br>Choose a better element?<br>Should I let this all unfold?</p><p>(Chorus)</p><p>(Instrumental Break)</p><p>(Instrumental Outro)</p><p>Abandon launch!<br>Abandon launch!",
      mp3src: require('../audio/full-length/the-factory-bloc/abandon-launch.mp3'),
      loaded: false,
      length: 242, // length in seconds
      // ! Important ! # of waves needs to be 54
      waves: [
        0.1645,
        0.3103,
        0.7109,
        0.7180,
        0.7224,
        0.7443,
        0.7780,
        0.7211,
        0.7561,
        0.7870,
        0.7580,
        0.8602,
        0.9006,
        0.9289,
        0.8637,
        0.9092,
        0.8889,
        0.9277,
        0.8962,
        0.6052,
        0.6269,
        0.6381,
        0.7520,
        0.8149,
        0.7933,
        0.9006,
        0.8520,
        0.8936,
        0.8842,
        0.9070,
        0.9177,
        0.9407,
        0.7314,
        0.5688,
        0.5514,
        0.5992,
        1.0000,
        0.9489,
        0.9946,
        0.8815,
        0.8438,
        0.8229,
        0.8728,
        0.8830,
        0.9282,
        0.8588,
        0.8864,
        0.8539,
        0.8557,
        0.8112,
        0.5706,
        0.5835,
        0.5602,
        0.0830
      ]
    }
  ]
};
